class FixCtaEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const fixCta = document.querySelector('.c-fixCta');

    function toggleFixCtaClass() {
      if (window.scrollY >= 400) {
        fixCta.classList.add('is-active');
      } else {
        fixCta.classList.remove('is-active');
      }
    }

    window.addEventListener('scroll', toggleFixCtaClass);
    toggleFixCtaClass();
    

    // 要素を取得
    const $ctaElement = $('.c-fixCta');
    const $formElement = $('.s-form');

    if ($ctaElement.length === 0 || $formElement.length === 0) return; // 要素が存在しない場合は終了

    // スクロールイベントリスナーを追加
    $(window).on('scroll', function() {
        // s-formの位置を取得
        const formTop = $formElement.offset().top;

        // 現在のスクロール位置を取得
        const scrollPosition = $(window).scrollTop();

        // c-fixCtaがs-formに到達したかどうかを判定
        if (scrollPosition >= formTop) {
            $ctaElement.addClass('is-hidden');
        } else {
            $ctaElement.removeClass('is-hidden');
        }
    });
  }
}
